import React, { useEffect } from 'react'


const TableX1 = props => {

	const {
		children
	} = props

	useEffect(() => {
		tableX1Handler()
	}, [])

	function tableX1Handler() {

		var isEven, tableItemX1

		tableItemX1 = document.getElementsByClassName("table_item_x1")

		isEven = tableItemX1.length % 2 === 0 ? true : false
		// beforeLast = isEven ? arr.length - 2 : arr.length - 1

		// for (var i = 0; i < array.length; i++) {
		// 	array[i]
		// }

		// console.log("tableItemX1.length == ", tableItemX1.length)

	}

	return (
		<div className="table_x1">
			{children}
		</div>
	)

}


export default TableX1
